import { render, staticRenderFns } from "./SkeletalLoader.vue?vue&type=template&id=56e5013c&"
import script from "./SkeletalLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletalLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports